module.exports = __webpack_public_path__ + "static/AIforDefense_header2x-95a68ede6d5c710566f3cf7dc7a1a969.png";